// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.svg-background {
  width: 100%;
  height: 100%;
  --amount: 100;
}

.svg-background span {
  width: 3vmin;
  height: 6vmin;
  border-radius: 3vmin;
  backface-visibility: hidden;
  position: absolute;
  animation-name: move;
  animation-timing-function: cubic-bezier(0.4, 0, 1, 0.8);
  animation-iteration-count: infinite;
  animation-duration: 3s;
  top: calc(50% - 3vmin);
  left: 50%;
  transform-origin: -3vmin center;
}
.svg-background span:nth-child(1) {
  background: #02bfff;
  animation-delay: -0.5s;
  opacity: 0;
}
.svg-background span:nth-child(2) {
  background: #19608f;
  animation-delay: -1s;
  opacity: 0;
}
.svg-background span:nth-child(3) {
  background: #02bfff;
  animation-delay: -1.5s;
  opacity: 0;
}
.svg-background span:nth-child(4) {
  background: #19608f;
  animation-delay: -2s;
  opacity: 0;
}
.svg-background span:nth-child(5) {
  background: #02bfff;
  animation-delay: -2.5s;
  opacity: 0;
}
.svg-background span:nth-child(6) {
  background: #7db7cc;
  animation-delay: -3s;
  opacity: 0;
}

@keyframes move {
  0% {
    transform: scale(1) rotate(0deg) translate3d(0, 0, 1px);
  }
  30% {
    opacity: 1;
  }
  100% {
    z-index: 10;
    transform: scale(0) rotate(360deg) translate3d(0, 0, 1px);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/LoadingSvg2.scss"],"names":[],"mappings":"AAGA;EACE,WAAA;EACA,YAAA;EACA,aAAA;AAFF;;AASA;EACE,YAAA;EACA,aAAA;EACA,oBALe;EAMf,2BAAA;EACA,kBAAA;EACA,oBAAA;EACA,uDAAA;EACA,mCAAA;EACA,sBAbkB;EAclB,sBAAA;EACA,SAAA;EACA,+BAAA;AANF;AAeI;EACE,mBAAA;EACA,sBAAA;EACA,UAAA;AAbN;AAUI;EACE,mBAAA;EACA,oBAAA;EACA,UAAA;AARN;AAKI;EACE,mBAAA;EACA,sBAAA;EACA,UAAA;AAHN;AAAI;EACE,mBAAA;EACA,oBAAA;EACA,UAAA;AAEN;AALI;EACE,mBAAA;EACA,sBAAA;EACA,UAAA;AAON;AAVI;EACE,mBAAA;EACA,oBAAA;EACA,UAAA;AAYN;;AAPA;EACE;IACE,uDAAA;EAUF;EAPA;IACE,UAAA;EASF;EANA;IACE,WAAA;IACA,yDAAA;EAQF;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
